import { useWorklogInfo } from '../../Hooks/Features/employeeDashboard/useWorklogInfo';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { SkeletonContainer } from '../Loader/Loader';

const WorklogInfo = () => {
    const { options, loader, noData } = useWorklogInfo();

    return (
        <div title='Worklog Info by Categories' className='w100 employee-dash-height'>
            {loader ? <SkeletonContainer /> :
                <div className='w100' style={{height: "100%" }}>
                    {noData ?
                        <div className='text-center'>
                            <img src={"./assets/nodata.jpg"} alt='no data'  fetchpriority="high"/>
                            <p className='text-center red mt-3'> Data Not Found</p>
                        </div> :
                        <HighchartsReact highcharts={Highcharts} options={options} containerProps={{
                            style: {
                                height: "100%"
                            }
                        }} />
                    }
                </div>
            }
        </div>
    )
}

export default WorklogInfo